import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Tabs } from '../../ui';
import { SecuritySettingsPage } from '../security/SecuritySettingsPage';
import { ProfileTab } from './ProfileTab';
import './AccountPage.css';

type AccountTab = 'profile' | 'security';

const TABS: { value: AccountTab; label: string }[] = [
  { value: 'profile', label: 'Profile' },
  { value: 'security', label: 'Security' },
];

function isAccountTab(value: string | null): value is AccountTab {
  return value === 'profile' || value === 'security';
}

export function AccountPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const rawTab = searchParams.get('tab');
  const activeTab = useMemo<AccountTab>(
    () => (isAccountTab(rawTab) ? rawTab : 'profile'),
    [rawTab]
  );

  const handleChange = (next: AccountTab) => {
    const params = new URLSearchParams(searchParams);
    if (next === 'profile') {
      params.delete('tab');
    } else {
      params.set('tab', next);
    }
    setSearchParams(params, { replace: true });
  };

  return (
    <div className="account-page">
      <header className="account-page__header">
        <h1>Account</h1>
        <p>Manage your profile and security settings.</p>
      </header>

      <Tabs<AccountTab>
        value={activeTab}
        onChange={handleChange}
        tabs={TABS}
        ariaLabel="Account sections"
        className="account-page__tabs"
      />

      <div role="tabpanel" className="account-page__panel">
        {activeTab === 'profile' ? <ProfileTab /> : <SecuritySettingsPage />}
      </div>
    </div>
  );
}
